// const wp_uri = "https://adventuregenie-wp-staging-csa9d8g4dwhmaees.eastus2-01.azurewebsites.net"
const wp_uri = "https://wp.adventuregenie.com"

import Swiper from 'swiper';
// import { Navigation, Pagination } from 'swiper/modules';

function fetch_post(element:HTMLElement, post_slug:string) {
	fetch(`${wp_uri}/wp-json/wp/v2/posts?slug=${post_slug}`)
	.then(r => r.json())
	.then(posts => {
		if (posts.length > 0) {
		const post_id = posts[0].id;
		console.log("post_id", post_id);
		embed_content(element, `${wp_uri}/wp-json/custom/v1/post/${post_id}/`);
		} else {
		throw new Error("Post not found");
		}
	});
};

function handle_sub_btns() {
	const sub_lvl:number = parseInt(window.GAsubLevel);
	if (sub_lvl >= 1) {
		//subscribed or in trial
		$(".sub_btn").remove();
	};
}

function handle_partner_btn_updates() {
	const sub_lvl:number = parseInt(window.GAsubLevel);
	if (sub_lvl > 1) {
		//subscribed
		return;
	};
	const partner_btns = $(".partner_discount_btn");
	if (Number.isNaN(sub_lvl) || sub_lvl == 0) {
		//anon or member
		partner_btns.find(".uagb-button__link").text("Go Pro to redeem");
		partner_btns.find("a").attr("href","/login?screen=signup&action=subscribe");
	} else {
		//in trial
		partner_btns.find(".uagb-button__link").text("Redeem when your trial ends");
		partner_btns.css("opacity","0.75");
		partner_btns.find("a").css("pointer-events","none");
		partner_btns.find("a").attr("href","#");
		partner_btns.find("a").attr("onclick","return false;");
		partner_btns.find("a").attr("aria-disabled","true");
	};
};

function embed_content(el:HTMLElement, uri:string, is_post:boolean = false) {
	fetch(uri)
	.then(response => response.json())
	.then(response => {
		if (is_post) {
			el.innerHTML = `
			<div class="wp-embed-wrapper" style="--wp--style--global--wide-size: 100%; --wp--style--root--padding-left: 0; --wp--style--root--padding-right: 0;">
				${response.content}
			</div>
			`;
		} else {
			el.innerHTML = response.content;
		};


		const $elementsDiv = $(document.createElement("div"));
		$elementsDiv.append(response.head);
		$elementsDiv.find("meta").remove();
		document.head.append(...$elementsDiv.children());

		const swiper = new Swiper('.uagb-swiper', {
			speed: 400,
			spaceBetween: 100,
			loop:true,
			});

			$(swiper.el).parent().find(".swiper-button-next").on("click", () => {console.log("CLICKED NEXT");swiper.slideNext()})
			$(swiper.el).parent().find(".swiper-button-prev").on("click", () => {swiper.slidePrev()})

			handle_partner_btn_updates();
			handle_sub_btns();
	})
	.catch(error => console.error('Error fetching page:', error));
};

$(function() {
	const wordpressSections:NodeListOf<HTMLElement> = document.querySelectorAll("[wordpress-cms-section]");

	wordpressSections.forEach(el => {
		const slug:string |undefined= el.getAttribute("page_slug");
		const post_slug:string |undefined= el.getAttribute("post_slug");
		let uri:string|undefined = undefined;
		if (post_slug != undefined) {
			return fetch_post(el, post_slug);
		}


		if (slug != undefined) {
			uri = `${wp_uri}/wp-json/wp/v2/pages?slug=${slug}`;
		} else {
			const post_id:string|undefined = el.getAttribute("post_id");
			if (post_id != undefined) {
				uri = `${wp_uri}/wp-json/custom/v1/page/${post_id}/`
			};

		};
		if (uri != undefined) {
			embed_content(el, uri);
		};
	});
});

